export default "__VITE_ASSET__DJOza2_6__"